import $ from 'jquery';
import { stripExtension } from '@/assets/js/Utilities';

export default class CustomLUT {
    constructor() {
        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
    }

    async addBlock(blockNum = lutify.blocks.length, data) {
        UI.createAdjustmentBlockTemplate('custom-lut', blockNum, data);
        let $element = $(UI.getAdjustmentBlock(blockNum));

        if (lutify.activeSidebarContainer !== 'blocks') {
            UI.container.sidebarSelector.find('[data-container="blocks"]').trigger('click');
        }

        UI.appendBlockLoadingSpinner($element);
        UI.scrollToBlock(lutify.activeBlock);
        UI.hideLUTtemplates();

        if (luts.loaded.customLUT.initialLoad) {
            let folders = await vm.$store.dispatch('UserFilesCustomLuts/index');
            luts.loaded.customLUT.initialLoad = false;
        }

        $element.on('click', e => {
            const folderId = lutify.getActiveBlock().folder.id || lutify.getActiveBlock().selectedPreviewFolder;
            const folder = vm.$store.getters['UserFilesCustomLuts/folder'](folderId);

            this.refreshAllBlocks();
            if (lutify.activePreviewsSidebarContainer !== 'previews') UI.container.previewsSidebarSelector.find('[data-container="previews"]').trigger('click');

            if (folder.id) {
                this.showPreviews(folder);
            } else UI.hideLUTtemplates();
        });

        $element.find('.btn-reset-block').off('click').on('click', e => this.resetBlock($element, e));
        // $element.find(".btn-remove-lut-selection").on("click", e => {
        //     e.stopPropagation();
        //     this.removeLutSelection(lutify.getActiveBlock());
        // });
        $element.find('.opacity_slider').on('input', _ => this.opacitySliderHandler($element));
        $element.find('.opacity-input').on('change', _ => this.opacityInputHandler($element));

        $element.find('.control-selector__label-container').on('click', e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass('--disabled')) return;
            this.toggleCustomLutDropdown(true);
            this.toggleFolderDropdown();
        });

        $element.find('.lut-selector__label-container').on('click', e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass('--disabled')) return;
            $element.click();
            this.toggleFolderDropdown(true);
            this.toggleCustomLutDropdown();
        });

        $element.find('.btn-create-custom-luts-folder').on('click', _ => {
            UI.showModal(UI.modals.customLUT.createFolder.el);
        });

        $element.find('.btn-edit-custom-luts').on('click', e => {
            UI.showModal(UI.modals.customLUT.edit.el);
        });

        blocks.add({
            name: data.control,
            control: data.control,
            passes: await this.addPasses(),
            blockNum,
            blendingMode: 0,
            blendingModeName: 'Normal',
            selectedPreviewFolder: null,
            opacity: 100,
            folder: {
                id: null,
                name: null
            },
            lut: {
                id: null,
                name: null
            },

        });

        if (!lutify.exportingLut && data.initial) {
            UI.container.previewsSidebarSelector.find('[data-container="previews"]').trigger('click');
        }

        this.refreshAllBlocks();

        UI.removeBlockLoadingSpinner($element);

        $element.find('.expand_options').trigger('click', [false]);
        UI.attachTemporaryLUTSelectionHandler();

        // this.toggleFolderDropdown(true);
    }

    refreshAllBlocks() {
        lutify.blocks.forEach(block => {
            if (block.control !== 'customLUT') return;

            const $block = UI.getBlock(block.blockNum);
            if (!$block) return;

            let folder = vm.$store.getters['UserFilesCustomLuts/folder'](block.folder.id);

            if (block.folder.id && !folder.id) {
                block.folder = {
                    id: null,
                    name: null
                };
            }

            folder = vm.$store.getters['UserFilesCustomLuts/folder'](block.selectedPreviewFolder);
            if (block.selectedPreviewFolder && !folder.id) {
                block.selectedPreviewFolder = null;
            }

            const lut = vm.$store.getters['UserFilesCustomLuts/lut'](block.lut.id);

            if (block.lut.id && !lut.id) {
                this.showBlockWarn($block);
                this.removeLutSelection(block, false);

                block.lut = {
                    id: null,
                    name: null
                };
            }

            let lutName = null;
            if (block.lut.id) lutName = block.lut.name;

            this.refreshFoldersList($block, folder.name);
            this.refreshCustomLutsList($block, folder, lutName);
        });
    }

    refreshFoldersList($block = UI.getActiveBlock(), folderName) {
        $block
            .find('.block-sliders-container')
            .addClass('--disabled');

        if (folderName) {
            $block
                .find('.block-sliders-container')
                .removeClass('--disabled');
        }

        let items = this.getFoldersListElements();
        if (!folderName) folderName = 'Select...';

        $block
            .find('.selected-control-name')
            .html(folderName);

        $block
            .find(`.control-selector__items-container > span`)
            .remove();

        if (items.length == 0) {
            $block
                .find('.control-selector__label-container')
                .addClass('--disabled');

            return;
        }

        $block
            .find('.control-selector__label-container')
            .removeClass('--disabled');
        $block
            .find('.control-selector__items-container')
            .append(items);
    }

    getFoldersListElements() {
        let items = [];
        vm.$store.state.UserFilesCustomLuts.customLuts.forEach(folder => {
            let item = document.createElement('span');
            item.setAttribute('data-folder', folder.id);
            item.innerHTML = folder.name;

            $(item).on('click', e => {
                e.stopPropagation();
                this.folderSelectionHandler(folder);
            });

            items.push(item);
        });
        return items;
    }

    async folderSelectionHandler(folder) {
        this.toggleFolderDropdown();

        let $block = UI.getActiveBlock();
        UI.appendBlockLoadingSpinner($block);
        lutify.getActiveBlock().selectedPreviewFolder = folder.id;

        // this.resetOpacity($block);
        // this.resetBlendingMode($block);
        this.refreshAllBlocks();

        if (!luts.customLUT[folder.id] || luts.customLUT[folder.id].length == 0) {
            UI.togglePreviewsContainer();
            UI.updatePreviewsTab(folder.name);
            lutPreviewer.showPlaceholderPreviews();
            await this.fetchCustomLutFiles(folder);
        }

        lutPreviewer.removePlaceholderPreviews();
        this.showPreviews(folder);
        this.removeLutSelection(lutify.getActiveBlock());

        UI.removeBlockLoadingSpinner($block);
    }

    refreshCustomLutsList($block = UI.getActiveBlock(), folder, lutName) {
        let items = [];
        if (!lutName) lutName = 'None';
        else lutName = stripExtension(lutName)

        if (folder) items = this.createCustomLutsListItemElementsList(folder);

        $block
            .find('.selected-lut-name')
            .html(lutName);

        $block
            .find(`.lut-selector__items-container > span`)
            .remove();

        if (items.length == 0) {
            $block
                .find('.lut-selector__label-container')
                .addClass('--disabled');

            return;
        }

        $block
            .find('.lut-selector__label-container')
            .removeClass('--disabled');
        $block
            .find('.lut-selector__items-container')
            .append(items);
    }

    createCustomLutsListItemElementsList(folder) {
        let items = [];
        folder.files.forEach(lut => {
            let item = document.createElement('span');
            item.setAttribute('data-file-id', lut.id);
            item.setAttribute('data-composer-index', luts.getComposerIndexById('customLUT', lut.id));

            item.innerHTML = stripExtension(lut.name);
            $(item).on('click', async e => {
                e.stopPropagation();
                await this.customLutSelectionHandler(folder, lut);
            });
            items.push(item);
        });
        return items;
    }

    async customLutSelectionHandler(folder, lut, triggerPreview = true) {
        this.toggleCustomLutDropdown();
        this.removeBlockWarn();
        this.removeBlockInfo();

        lutify.getActiveBlock().folder = {
            id: folder.id,
            name: folder.name
        };

        lutify.getActiveBlock().lut = {
            id: lut.id,
            name: lut.name
        };

        lutify.getActiveBlock().selectedPreviewFolder = folder.id;

        let $block = UI.getActiveBlock();
        this.refreshCustomLutsList($block, folder, lut.name);

        const composerIndex = luts.getComposerIndexById('customLUT', lut.id);

        const reader = new FileReader();
        reader.readAsBinaryString(luts.getFileById('customLUT', lut.id));
        await new Promise((resolve, reject) => {
            reader.onload = async event => {
                lutify.getActiveBlock().lutContent = reader.result;
                lutify.getActiveBlock().lutOwner = vm.$store.state.User.user.name;
                lutify.getActiveBlock().lutName = lut.name;
                lutify.getActiveBlock().lutId = lut.id;
                resolve();
            };
        });

        if (triggerPreview) $(`#previews-list-container > .list-item[data-composer-index="${composerIndex}"]`).trigger('click');
    }

    async fetchCustomLutFiles(folder) {
        const luts = await vm.$store.dispatch('UserFilesCustomLuts/fetch', folder);
        await this.createLUTobjects(luts, folder.id);
        this.refreshAllBlocks();
    }

    async createLUTobjects(lutList, folderId) {
        if (!luts.customLUT[folderId]) luts.customLUT[folderId] = [];

        lutList = lutList.filter(lut => {
            if (luts.customLUT[folderId].find(lutObject => lutObject.lutId == lut.id)) return false;
            else return lut;
        });

        let lutObjects = await luts.load(lutList.map(lut => lut.file), luts.customLUT[folderId]);

        lutObjects.forEach((lut, i) => {
            lut.file = lutList[i].file;
            lut.control = 'customLUT';
            lut.category = folderId;
            lut.lutId = lutList[i].id;
            lut.folderId = lutList[i].folderId;
            lut.title = stripExtension(lutList[i].name);
        });

        lutPreviewer.createPreviews(lutObjects, 'canRemove');
        lutPreviewer.sortPreviews(
            folderId,
            luts.customLUT[folderId].map(item => item.title)
        );
    }

    toggleFolderDropdown(forceHide = false) {
        const $block = UI.getActiveBlock();
        let itemsContainer = $block.find('.control-selector__items-container');

        if (forceHide) {
            itemsContainer.hide();
            return;
        }

        if (itemsContainer.is(':visible')) itemsContainer.hide();
        else itemsContainer.show();
    }

    toggleCustomLutDropdown(forceHide = false) {
        const $block = UI.getActiveBlock();
        let itemsContainer = $block.find('.lut-selector__items-container');

        if (forceHide) {
            itemsContainer.hide();
            return;
        }

        if (itemsContainer.is(':visible')) itemsContainer.hide();
        else itemsContainer.show();
    }

    async addPasses() {
        const renderPass = gpu.createRenderPass();
        gpu.addPassToComposer(renderPass, 'toMiddle');

        return [renderPass];
    }

    showPreviews(folder) {
        if (!folder.id) return;

        UI.togglePreviewsContainer();
        UI.updatePreviewsTab(folder.name);
        lutPreviewer.switchCanvases(folder.id, 'customLUT');

        const composerIndex = luts.getComposerIndexById('customLUT', lutify.getActiveBlock().lut.id);
        if (lutify.getActiveBlock().lut.id) UI.updateSelectedPreview(composerIndex);

        lutPreviewer.cloneMainComposerPasses();
        lutPreviewer.addPass(lutify.getActiveBlock().control, folder.id, 0, lutify.getActiveBlock().blendingMode);
        lutPreviewer.render();
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find('.opacity_slider').val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find('.opacity-input').val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

        lutPreviewer.updateOpacity(calcOpacityValue);
        UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find('.opacity-input').val();
        let opacitySlider = $element.find('.opacity_slider');

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger('input');
    }

    showBlockWarn($block = UI.getActiveBlock()) {
        this.removeBlockWarn($block);

        let htmlWarn = '<i class="material-icons block-warn" data-tippy-content="LUT is missing">error_outline</i>';
        $block.find('.header-container .controls-wrapper').prepend(htmlWarn);
    }

    showBlockInfo($block = UI.getActiveBlock()) {
        this.removeBlockInfo($block);

        const htmlWarn = '<i class="material-icons block-info" data-tippy-content="This block uses a custom LUT not from your library or the LUT might have been deleted.">error_outline</i>';
        $block.find('.header-container .controls-wrapper').prepend(htmlWarn);

        const lutName = lutify.getActiveBlock().lutName;
        const lutOwner = lutify.getActiveBlock().lutOwner;
        const htmlMessage = `
            <div class="block-message">
                <div class="d-flex justify-space-between align-center mb-2" style="line-height: 1.2">
                    <span>Custom LUT</span>
                    <span class=" d-block">${lutName}</span>
                </div>
                <div class="d-flex justify-space-between align-center mb-6" style="line-height: 1.2">
                    <span>Owned by</span>
                    <span class=" d-block">${lutOwner}</span>
                </div>
                <span class="d-block mb-2" style="line-height: 1.2">You cannot edit deleted LUTs or LUTs owned by another user.</span>
            </div>
        `;

        $block.find('.block_options').append(htmlMessage);

        // $block.find(".block_options .custom-lut-buttons-container").removeClass('d-flex');
        $block.find('.block_options .block-option').removeClass('d-flex');

        // $block.find(".block_options .custom-lut-buttons-container").addClass('d-none');
        $block.find('.block_options .block-option').addClass('d-none');
        $block.find('.block_options .block-sliders-container ').addClass('d-none');
    }

    removeBlockWarn($block = UI.getActiveBlock()) {
        $block.find('.header-container .block-warn').remove();
    }

    removeBlockInfo($block = UI.getActiveBlock()) {
        $block.find('.header-container .block-info').remove();
        $block.find('.block_options .block-message').remove();

        // $block.find(".block_options .custom-lut-buttons-container").addClass('d-flex');
        $block.find('.block_options .block-option').addClass('d-flex');

        // $block.find(".block_options .custom-lut-buttons-container").removeClass('d-none');
        $block.find('.block_options .block-option').removeClass('d-none');
        $block.find('.block_options block-sliders-container ').removeClass('d-none');
    }

    resetOpacity($block) {
        $block.find('.opacity-input').val(100);
        $block.find('.opacity-input').trigger('change');
    }

    resetBlendingMode($block) {
        $block.find('.blending-mode__items-container > span[data-id="0"]').trigger('click');
    }

    async resetBlock($block, e) {
        e.stopPropagation();
        this.resetOpacity($block);
        this.resetBlendingMode($block);

        UI.scrollToSelectedPreview();

        lutify.getActiveBlock().folder = {
            id: null,
            name: null
        };

        lutify.getActiveBlock().selectedPreviewFolder = null;
        this.removeLutSelection(lutify.getActiveBlock());
        UI.hideLUTtemplates();

        const renderPass = gpu.createRenderPass();
        renderPass.uid = lutify.getActiveBlock().passes[0].uid;
        const passIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
        lutify.getActiveBlock().passes[0] = renderPass;
        gpu.composer.passes[passIndex] = lutify.getActiveBlock().passes[0];

        gpu.render();
        lutPreviewer.render();
    }

    removeLutSelection(block, refresh = true) {
        block.lut = {
            id: null,
            name: null
        };

        UI.deselectPreview();
        if (refresh) this.refreshAllBlocks();
        block.passes[0].enabled = false;
        gpu.render();
    }

    async applyCompare($block, data) {
        if (!data.lut.id && !data.lutContent) return;

        let folder = vm.$store.getters['UserFilesCustomLuts/folder'](data.folder.id);
        let lut = vm.$store.getters['UserFilesCustomLuts/lut'](data.lut.id);

        if (!lut.id) {
            lut = vm.$store.getters['UserFilesCustomLuts/lut'](data.lutId);
            if (lut.id) {
                folder = vm.$store.getters['UserFilesCustomLuts/folderByLutId'](data.lutId);
            }
        }

        if (lut.id) {
            if (folder.id) {
                await this.folderSelectionHandler(folder);
                this.toggleFolderDropdown(true);
            }

            await this.customLutSelectionHandler(folder, lut);
            this.toggleCustomLutDropdown(true);

            $block.find('.opacity-input').val(parseInt(data.opacity));
            $block.find('.opacity-input').trigger('change');

            if (data.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${data.blendingMode}"]`).trigger('click');
        } else if (data.lutContent) {
            const file = new File([data.lutContent], data.lut.name);
            const lutObjects = await luts.load([file]);
            const pass = gpu.createLUTPass(lutObjects[0].texture);
            pass.uid = lutify.getActiveBlock().passes[0].uid;
            pass.uniforms.opacity.value = parseInt(data.opacity) / 100;

            lutify.getActiveBlock().passes[0] = pass;
            let passIndex = gpu.getPassIndexById(pass.uid);
            gpu.composer.passes[passIndex] = pass;

            if (data.active == 0) $block.find('.controls-wrapper .switch > input').trigger('click');

            gpu.render();
            lutPreviewer.render();

            lutify.getActiveBlock().lutContent = data.lutContent;
            lutify.getActiveBlock().lutOwner = data.lutOwner;
            lutify.getActiveBlock().lutName = data.lutName;
            lutify.getActiveBlock().lutId = data.lutId;
            this.showBlockInfo();

            if (data.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${data.blendingMode}"]`).trigger('click');
        } else {
            this.showBlockInfo();
        }
    }
}
